// exports of our version of react-apollo's components and hooks, with proper integration for UFO holds
export { Query, Mutation, Subscription } from './components';
export {
	useQuery,
	useLazyQuery,
	useMutation,
	useSubscription,
	RenderPromises,
	useApolloClient,
} from './react-hooks';

// pass through exports of react-apollo's own exports
// required as we do a normal module replacement in confluence's webpack config to replace `react-apollo` with `@atlassian/ufo-apollo-log`
export {
	getApolloContext,
	resetApolloContext,
	ApolloProvider,
	ApolloConsumer,
	graphql,
	withQuery,
	withMutation,
	withSubscription,
	withApollo,
	getMarkupFromTree,
	getDataFromTree,
	renderToStringWithData,
} from 'react-apollo';

export type {
	ApolloContextValue,
	OperationVariables,
	Context,
	ExecutionResult,
	BaseQueryOptions,
	QueryFunctionOptions,
	ObservableQueryFields,
	QueryResult,
	RefetchQueriesFunction,
	BaseMutationOptions,
	MutationFunctionOptions,
	MutationResult,
	MutationFetchResult,
	MutationFunction,
	OnSubscriptionDataOptions,
	BaseSubscriptionOptions,
	SubscriptionResult,
	QueryComponentOptions,
	MutationComponentOptions,
	SubscriptionComponentOptions,
	DataValue,
	DataProps,
	MutateProps,
	ChildProps,
	ChildDataProps,
	ChildMutateProps,
	OptionProps,
	OperationOption,
	WithApolloClient,
	CommonOptions,
	QueryOptions,
	QueryHookOptions,
	QueryPreviousData,
	QueryCurrentObservable,
	MutationHookOptions,
	MutationOptions,
	MutationTuple,
	SubscriptionHookOptions,
	SubscriptionOptions,
	SubscriptionCurrentObservable,
} from 'react-apollo';
